const EMAIL_REGEX = /^[\w+\-.]+@[a-z\d\-.]+\.[a-z]+$/i;

export default email => EMAIL_REGEX.test(email);
